module.exports = __webpack_public_path__ + "assets/images/HighFiveSquare.da15d0c57e0cb0bbdfb01786ccf1ab9b.svg";